import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=22fed976&"
import script from "./Inventories.vue?vue&type=script&lang=js&"
export * from "./Inventories.vue?vue&type=script&lang=js&"
import style0 from "./Inventories.vue?vue&type=style&index=0&id=22fed976&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports